import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ca-bots-logo',
  standalone: true,
  templateUrl: './bots-logo.component.html',
  styleUrl: './bots-logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BotsLogoComponent {
}
